//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import template from './non-business-tooltip.html';
import './non-business-tooltip.less';

export class NonBusinessTooltip {
  constructor(public IG_DEPRECATION_LEARN_MORE_URL) {}
}

angular.module('curalate').component('nonBusinessTooltip', {
  bindings: {},
  controller: [
    'IG_DEPRECATION_LEARN_MORE_URL',
    NonBusinessTooltip,
  ],
  template,
});
